module.exports = __webpack_public_path__ + "static/media/eth1.5b269438.png";